<div class="flex flex-col items-start">
  <ng-container *ngFor="let item of customPresets">
    <button *ngIf="!picker?.excludedRanges?.includes(item)" mat-button color="accent" (click)="selectPeriod(item)">
      {{ item }}
    </button>
  </ng-container>
</div>
